import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import UploadImage from "../../components/UploadImage";
import TrimSpecsManager from "../../components/TrimSpecsManager";
import TrimColorsManager from "../../components/TrimColorsManager";
import "../../styles/Edit.css";
import backendUrl from "../../BackendUrl";


const EditTrim = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [trimData, setTrimData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const adminToken = localStorage.getItem('adminToken');

  useEffect(() => {
    const fetchTrimData = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/vehicles/get-trim/${id}`);
        setTrimData(response.data);
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch trim data. Please try again later.");
        setLoading(false);
      }
    };

    fetchTrimData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTrimData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(`${backendUrl}/api/vehicles/update-trim/${id}`, trimData, {headers: {Authorization: `Bearer ${adminToken}`,},});
      setTrimData(response.data);
      alert("Trim updated successfully!");
    } catch (error) {
      alert("Failed to update trim. Please try again later.");
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this trim?")) {
      try {
        await axios.delete(`${backendUrl}/api/vehicles/delete-trim/${id}`, {headers: {Authorization: `Bearer ${adminToken}`,},});
        alert("Trim deleted successfully.");
        navigate("/edit-website");
      } catch (error) {
        alert("Failed to delete the trim. Please try again later.");
      }
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="edit-class-container">
      <div className="edit-form">
        <h2>Edit Trim</h2>
        <form onSubmit={handleSubmit}>
          <label>
            Trim Name:
            <input
              type="text"
              name="trim"
              value={trimData?.trim || ""}
              onChange={handleInputChange}
            />
          </label>
          <label>
            Description:
            <textarea
              name="description"
              value={trimData?.description || ""}
              onChange={handleInputChange}
              rows={4}
            />
          </label>
          <label>
            Price: 
            <input
              type="number"
              name="price"
              value={trimData?.price || ""}
              onChange={handleInputChange}
            />
          </label>
          <label>
            MPG City:
            <input
              type="number"
              name="mpgCity"
              value={trimData?.mpgCity || ""}
              onChange={handleInputChange}
              step="any"
            />
          </label>
          <label>
            MPG Highway:
            <input
              type="number"
              name="mpgHwy"
              value={trimData?.mpgHwy || ""}
              onChange={handleInputChange}
              step="any"
            />
          </label>
          <label>
            MPG Combined:
            <input
              type="number"
              name="mpgCmb"
              value={trimData?.mpgCmb || ""}
              onChange={handleInputChange}
              step="any"
            />
          </label>
          <label>
            Mileage:
            <input
              type="number"
              name="mileage"
              value={trimData?.mileage || ""}
              onChange={handleInputChange}
              step="any"
            />
          </label>
          <label>
            Weight:
            <input
              type="number"
              name="weight"
              value={trimData?.weight || ""}
              onChange={handleInputChange}
              step="any"
            />
          </label>
          <label>
            Seats:
            <input
              type="number"
              name="seats"
              value={trimData?.seats || ""}
              onChange={handleInputChange}
            />
          </label>
          <label>
            Engine:
            <input
              type="text"
              name="engine"
              value={trimData?.engine || ""}
              onChange={handleInputChange}
            />
          </label>
          <label>
            Transmission:
            <input
              type="text"
              name="transmission"
              value={trimData?.transmission || ""}
              onChange={handleInputChange}
            />
          </label>

          {/* READY TOGGLE */}
          <label className="toggle">
            <input
              type="checkbox"
              name="ready"
              checked={trimData?.ready || false}
              onChange={(e) =>
                setTrimData((prev) => ({
                  ...prev,
                  ready: e.target.checked,
                }))
              }
            />
            <span>Ready</span>
          </label>

          <button type="submit">Save Changes</button>

          {/* Upload Trim Image Section */}
          <UploadImage
            uploadUrl="/api/vehicles/upload-trim"
            id={id}
            onUploadSuccess={(data) => console.log("Uploaded trim image:", data)}
          />

          {/* Trim Specs Manager Section */}
          <h3>Specifications</h3>
          <TrimSpecsManager
            trimId={id}
            trimSpecs={trimData?.specs || []}
            onUpdate={(updatedSpecs) =>
              setTrimData((prev) => ({ ...prev, specs: updatedSpecs }))
            }
          />

          {/* Trim Colors Manager Section */}
          <TrimColorsManager
            trimId={id}
            trimColors={trimData?.colors || []}
            onUpdate={(updatedColors) =>
              setTrimData((prev) => ({ ...prev, colors: updatedColors }))
            }
          />
        </form>
        {/* Delete button */}
        <button
          type="button"
          onClick={handleDelete}
          style={{ backgroundColor: "red", color: "white", marginTop: "1rem" }}
        >
          Delete Trim
        </button>
      </div>

      {/* Right Section: Display */}
      <div className="display-section">
        {trimData?.trimImg && (
          <div className="image-container">
            <img src={trimData.trimImg} alt="Trim" />
            <div className="image-title">{trimData?.trim || "N/A"}</div>
          </div>
        )}
        <p className="description">
          {trimData?.description || "No description available"}
        </p>
        <p>
          {trimData?.price != null
            ? '$' + Number(trimData.price).toLocaleString(undefined, { maximumFractionDigits: 2 })
            : "No price available"}
        </p>
      </div>
    </div>
  );
};

export default EditTrim;